// src/pages/ProductList.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// import { human_products, IMAGE_BASE_PATH } from '../assets/data/human_prod';

// const IMAGE_BASE_PATH = '../assets/images/products/';

export default function ProductList({ products, categories, basePath }) {
  // 선택된 카테고리 ID 상태 (초기값은 '전체' 카테고리의 ID인 0)
  const [selectedCategoryId, setSelectedCategoryId] = useState(0);
  // 선택된 카테고리에 따라 제품 필터링
  const filteredProducts = products.filter((product) => {
    if (selectedCategoryId === 0) {
      // '전체' 카테고리 선택 시 모든 제품 표시
      return true;
    }
    // 제품의 categoryIds 배열에 선택된 카테고리 ID가 포함되어 있는지 확인
    return (
      product.categories &&
      product.categories.includes(Number(selectedCategoryId))
    );
  });

  return (
    <section className="max-w-7xl mx-auto px-4 py-12">
      {/* 하위 카테고리 메뉴 영역 */}
      <div className="mb-8 flex justify-center flex-wrap gap-4">
        {/* categories prop이 존재할 때만 렌더링 */}
        {categories &&
          categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setSelectedCategoryId(category.id)}
              className={
                `px-6 py-2 border border-gray-300 rounded-full text-gray-700 transition-colors
              ${
                selectedCategoryId === category.id
                  ? 'bg-blue-500 text-white'
                  : 'hover:bg-gray-100'
              }
              }` // 선택된 카테고리 스타일링
              }
            >
              {category.name}
            </button>
          ))}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6 gap-y-12">
        {filteredProducts.length > 0 ? (
          filteredProducts.map((product) => (
            <Link
              key={product.id}
              to={`/${basePath}/product/${product.slug}`}
              className="bg-gray-100 rounded-md overflow-hidden shadow hover:shadow-lg transition-shadow"
            >
              <div className="w-full h-64 overflow-hidden p-5">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="p-4 text-center font-semibold text-gray-800">
                {product.name}
              </div>
            </Link>
          ))
        ) : (
          <p className="col-span-full text-center text-gray-500">
            선택된 카테고리에 해당하는 제품이 없습니다.
          </p>
        )}
      </div>
    </section>
  );
}
